import { Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useUrl } from "../../../hooks/urlEncoding";
import { routerPaths } from "../../../constants/Paths";
import { FilterOperatorEnum } from "../../../services/Schemas/ListQueryString";
import { PaymentListColumnFilterable } from "../../../services/Endpoints/payments/PaymentListEndpoint";

interface IAgentLink {
  agent: {
    id: number;
    name?: null | string;
  };
  direction?: "column" | "row" | "row-reverse" | "column-reverse";
  disabled?: boolean;
}

export default function AgentLink({
  agent,
  direction = "column",
  disabled,
}: IAgentLink) {
  const { queryStringUrl } = useUrl();
  return (
    <Stack
      gap="1px"
      direction={direction}
      component={disabled ? Stack : Link}
      justifyContent="start"
      alignItems="center"
      sx={{
        textDecoration: "none",
      }}
      to={queryStringUrl(routerPaths.PAYMENTS, {
        filters: [
          {
            column: PaymentListColumnFilterable.ID,
            operator: FilterOperatorEnum.EQUAL,
            value: agent.id,
          },
        ],
      })}
    >
      {!agent.name && (
        <Typography
          textAlign="center"
          variant="footerRegular"
          color={(theme) =>
            !disabled ? theme.palette.others.link : theme.palette.dark[40]
          }
        >
          {agent.id}
        </Typography>
      )}
      <Typography
        textAlign="center"
        variant="footerRegular"
        color={(theme) =>
          !disabled ? theme.palette.others.link : theme.palette.dark[40]
        }
      >
        {agent.name}
      </Typography>
    </Stack>
  );
}
